import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { SelectedCount } from 'controlled-components'
import {
  openBottom,
  selectBottomDisabled,
  selectBottomSelectedItemsCount,
  selectBottomShowingSelections,
  setBottomShowingSelections,
} from 'slices/aiSegmentBuilder/picker'

// ═══════════════════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════════════════

interface OwnProps {
  pickerId: number
  disabled?: boolean
}

type Props = OwnProps & ConnectedProps<typeof connector>

// ═══════════════════════════════════════════════════════════════════════════
// Component
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Container for the selection count caption.
 * Only renders when there are selections.
 * Clicking opens the dropdown and shows the selections view.
 */
const CaptionContainer: React.FC<Props> = ({
  pickerId,
  disabled = false,
  selectionCount,
  showingSelections,
  reduxDisabled,
  open,
  setShowingSelections,
}) => {
  if (selectionCount === 0) {
    return null
  }

  // Combined disabled state (prop OR redux)
  const isDisabled = disabled || reduxDisabled

  const handleClick = () => {
    open({ pickerId })
    setShowingSelections({ pickerId, showingSelections: true })
  }

  return (
    <SelectedCount
      count={selectionCount}
      onClick={isDisabled ? undefined : handleClick}
      active={isDisabled ? false : showingSelections}
      style={{ marginLeft: 0, marginTop: '4px', display: 'inline-block' }}
    />
  )
}

// ═══════════════════════════════════════════════════════════════════════════
// Redux Connection
// ═══════════════════════════════════════════════════════════════════════════

const mapStateToProps = (state: any, ownProps: OwnProps) => ({
  selectionCount: selectBottomSelectedItemsCount(state, ownProps.pickerId),
  showingSelections: selectBottomShowingSelections(state, ownProps.pickerId),
  reduxDisabled: selectBottomDisabled(state, ownProps.pickerId),
})

const mapDispatchToProps = {
  open: openBottom,
  setShowingSelections: setBottomShowingSelections,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(CaptionContainer)
